<template>
	<div class="home">
		<div>
			<NavBar :nav="false" />
			<div class="nav"></div>
			<div class="content">
				<div class="list" v-if="list.length > 0">
					<div class="item" v-for="(item, index) in list" :key="index" @click="goNext(item, index)">
						<div class="cover"><img v-if="item.path" :src="item.path" /></div>
						<div class="title">
							<p>{{ item?.title || `&nbsp;` }}</p>
							<svg class="rightIcon" viewBox="0 0 1024 1024" version="1.1">
								<path d="M853.333 507.733H128V550.4h733.867L716.8 695.467l29.867 29.866 192-192-192-192L716.8 371.2l136.533 136.533z" fill="#ffffff"></path>
							</svg>
						</div>
					</div>
				</div>
				<div v-else class="empty">
					<template v-if="loading">加载中</template>
					<template v-else><van-empty :image="require(`@/assets/images/new/empty.svg`)" description="暂无内容" /></template>
				</div>
			</div>
			<float-btn></float-btn>
		</div>
	</div>
</template>

<script>
import { Toast, Empty } from 'vant';
import Crypt from '@bluedot-tech/vue-ui/es/utils/crypt';
import config from '../config/config';
import floatBtn from '@/components/FloatBtn.vue';
import NavBar from '@/components/NavBar.vue';
export default {
	components: {
		floatBtn,
		[Empty.name]: Empty,
		NavBar
	},
	data() {
		return {
			list: [],
			loading: true
		};
	},
	mounted() {
		// 页面浏览 监测
		this.$dataStatistics({ page_title: '行业应用' });
		this.initShare();
		this.getList();
	},
	methods: {
		getList() {
			this.list = [];
			this.loading = true;
			this.$http
				.get(`/api/platform/industry`, {
					params: {
						pageSize: 9999
					}
				})
				.then((res) => {
					console.log(res);
					const list = res.data?.data || [];
					this.list = list;
					this.loading = false;
				});
		},
		goNext(item, index) {
			console.log(item);
			this.$dataStatistics(
				{ event_type: 'click', page_title: '行业应用-详情' },
				JSON.stringify({
					title: `${item.name}`,
					id: item.id
				})
			);
			this.$router.push({ path: '/industrydetails', query: { id: item.id } });
		}
	}
};
</script>
<style lang="less" scoped>
.home {
	background: rgba(249, 247, 243, 0.66);

	.content {
		width: 828px;
		position: relative;
		overflow-y: auto;
		height: auto;
		z-index: 6;

		.empty {
			position: fixed;
			height: auto;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 1;
			overflow: hidden;
		}

		.list {
			overflow: hidden;
			display: block;
			padding: 40px 36px;
			white-space: pre-wrap;
			word-wrap: break-word;
			word-break: break-all;

			.item {
				border-radius: 10px;
				margin: 0 36px 32px 0;
				width: calc((100% - 36px) / 2);
				display: inline-block;
				position: relative;
				overflow: hidden;

				&:nth-child(2n) {
					margin-right: 0;
				}

				.cover {
					flex: 0 0 auto;
					width: 360px;
					height: 236px;
					position: relative;
					overflow: hidden;
					border-radius: 10px;

					img {
						width: 100%;
						height: 100%;
						display: block;
						object-fit: cover;
					}

					&::after {
						content: '';
						display: block;
						position: absolute;
						z-index: 1;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						background: url('~@/assets/images/new/mask.png') no-repeat center center;
						background-size: 100% 100%;
						opacity: 0.4;
					}
				}

				.title {
					padding: 20px 30px;
					position: absolute;
					left: 0;
					bottom: 0;
					width: 100%;
					height: auto;
					display: flex;
					align-items: center;
					justify-content: space-between;
					z-index: 11;

					p {
						font-weight: 400;
						font-size: 32px;
						color: #ffffff;
						line-height: 1;
						white-space: nowrap;
						word-wrap: normal;
						word-break: normal;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.rightIcon {
						flex: 0 0 auto;
						margin-left: 12px;
						width: 60px;
						height: 40px;
						box-sizing: content-box;
					}
				}
			}
		}
	}
}
</style>
